import { DEFAULT_MEMBERSHIP, readMembership, type MembershipState } from "../membership";
import { apiGet } from "./http";

interface ClientProfileResponse {
  data?: ClientProfilePayload;
  [key: string]: unknown;
}

export interface ClientProfilePayload {
  id?: string | number;
  sid?: string;
  public_id?: string;
  email?: string;
  nickname?: string;
  avatar_url?: string;
  bio?: string;
  level?: number;
  exp?: number;
  invite_code?: string;
  moons_balance?: number;
  member?: boolean;
  member_badge?: string;
  member_expire_at?: string | null;
  daily_free_limit?: number;
  used_free_today?: number;
  unread_messages?: number;
  [key: string]: unknown;
}

export interface ClientProfileResult {
  user: ClientProfilePayload;
  membership: MembershipState;
}

const pendingProfileRequests = new Map<string, Promise<ClientProfileResult>>();

export class ClientProfileClient {
  static async getMe(token: string): Promise<ClientProfileResult> {
    const normalizedToken = token.trim();
    if (!normalizedToken) throw new Error("Client profile requires an access token.");

    const pending = pendingProfileRequests.get(normalizedToken);
    if (pending) return pending;

    const request = apiGet<ClientProfileResponse>("/v1/client/me", { token: normalizedToken })
      .then((response) => {
        const user = response.data ?? (response as ClientProfilePayload);
        const membership = readMembership(user);

        return {
          user,
          membership: membership ?? DEFAULT_MEMBERSHIP
        };
      })
      .finally(() => {
        if (pendingProfileRequests.get(normalizedToken) === request) {
          pendingProfileRequests.delete(normalizedToken);
        }
      });

    pendingProfileRequests.set(normalizedToken, request);
    return request;
  }
}
